module.exports = __webpack_public_path__ + "img/home_list_icon3.cf6417dc.png";